var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscritorio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,139h93.6c8.6,0,15.6-7,15.6-15.6V29.8c0-8.6-7-15.6-15.6-15.6H20.6C12,14.1,5,21.1,5,29.8v93.6 C5,132,12,139,20.6,139z M20.6,295h93.6c8.6,0,15.6-7,15.6-15.6v-93.6c0-8.6-7-15.6-15.6-15.6H20.6c-8.6,0-15.6,7-15.6,15.6v93.6 C5,288,12,295,20.6,295z M176.6,295h93.6c8.6,0,15.6-7,15.6-15.6v-93.6c0-8.6-7-15.6-15.6-15.6h-93.6c-8.6,0-15.6,7-15.6,15.6 v93.6C161,288,168,295,176.6,295z M290.4,65.5l-56-56c-6.1-6.1-16-6.1-22.1,0l-56,56c-6.1,6.1-6.1,16,0,22.1l56,56 c6.1,6.1,16,6.1,22.1,0l56-56C296.5,81.5,296.5,71.6,290.4,65.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscritorio);
export default __webpack_public_path__ + "static/media/escritorio.94bbfde08cc76b0a2b3d2c0fc30d2ed5.svg";
export { ForwardRef as ReactComponent };